import { Stack, Typography, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getPrescriptionsWithSites } from '../Common';

interface VolumingSubStepsProps {
  careplanId: string;
  isVisible: boolean;
  data?: any;
}

const VolumingAndSpecialPhysicsConsultSubSteps = ({
  careplanId,
  isVisible,
  data,
}: VolumingSubStepsProps): JSX.Element => {
  const theme = useTheme();
  const location = useLocation();

  // Parse the URL to get the siteGroupIdx (which represents prescription index for voluming)
  const pathSegments = location.pathname.split('/');
  const volumingIndex = pathSegments.findIndex((segment) => ['voluming', 'specialPhysicsConsult'].includes(segment));
  const volumingIdx =
    volumingIndex !== -1 && volumingIndex + 1 < pathSegments.length ? pathSegments[volumingIndex + 1] : undefined;

  if (!isVisible) {
    return <></>;
  }

  const groups = getPrescriptionsWithSites(data?.prescriptionsByCareplan) || [];
  const groupIdx = volumingIdx !== 'last' ? volumingIdx : String(groups.length - 1);
  return (
    <>
      {groups?.map((group: any, groupIndex: number) => {
        const isActive = String(groupIndex) === (groupIdx || '0');

        return (
          <div key={group.id}>
            <Stack
              sx={{
                background: isActive ? theme.palette.action.focus : 'transparent',
                padding: '8px 16px',
              }}>
              <Typography
                variant="body2"
                color={isActive ? 'text.primary' : 'text.secondary'}
                data-testid={`voluming-substep-${group.id}${isActive ? '-active' : ''}`}>
                {`Prescription ${groupIndex + 1}`}
              </Typography>
            </Stack>
          </div>
        );
      })}
    </>
  );
};

export default VolumingAndSpecialPhysicsConsultSubSteps;
